import { render, staticRenderFns } from "./AdminMedicine.vue?vue&type=template&id=02b0bddc"
import script from "./AdminMedicine.js?vue&type=script&lang=js&external"
export * from "./AdminMedicine.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports